"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgQuestionFill = function SvgQuestionFill(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.425 19.425A10.5 10.5 0 1 1 4.575 4.576a10.5 10.5 0 0 1 14.85 14.849ZM12 5.962c-.849 0-1.695.317-2.34.848l.001-.002c-.652.536-1.17 1.355-1.17 2.366a1.125 1.125 0 1 0 2.25 0c0-.197.097-.42.347-.627.258-.21.58-.328.912-.335.894 0 1.258.512 1.258.962a.815.815 0 0 1-.11.468c-.088.141-.268.345-.688.639-.769.538-1.585 1.276-1.585 2.467a1.125 1.125 0 1 0 2.25 0c0-.028 0-.055.057-.133.08-.107.243-.263.569-.492.543-.38 1-.792 1.312-1.3.329-.533.447-1.085.447-1.65 0-1.98-1.684-3.21-3.51-3.21Zm1.06 11.599a1.5 1.5 0 1 1-2.12-2.121 1.5 1.5 0 0 1 2.12 2.12Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgQuestionFill);
var _default = exports["default"] = Memo;